import React, { useState, useEffect } from "react";
import { developAxios } from "../axios.config";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { store } from "react-notifications-component";
import { CSVReader } from "react-papaparse";

function OverviewForm() {
	const [course, setCourse] = useState("");
	const [courses, setCourses] = useState([]);
	const [selectLevel, setSelectLevel] = useState("");
	const [objective, setObjective] = useState("");
	const [takeaway, setTakeaway] = useState("");
	const buttonRef = React.createRef();
	// const { CSVReader } = useCSVReader();
	const [schedule, setSchedule] = useState([
		{
			date: "",
			topic: "",
			subTopic: "",
			classLink: "",
		},
	]);

	/**
	 *
	 * @param {String} value
	 * @param {String} type
	 * @param {Number} index
	 *
	 */

	function updateSchedule(value, type, index) {
		console.log(value);
		setSchedule((prev) => {
			let schedule_data = prev;
			schedule_data[index][type] = value;
			return [...prev];
		});
	}

	const addInput = () => {
		setSchedule((prev) => {
			let temp_arr = [...prev];
			temp_arr.push({
				date: "",
				topic: "",
				subTopic: "",
			});

			return temp_arr;
		});
	};

	const removeInput = (index) => {
		setSchedule((prev) => {
			let temp_arr = [...prev];
			temp_arr.splice(index, 1);
			return temp_arr;
		});
	};

	// select course
	useEffect(() => {
		const controller = new AbortController();

		developAxios(localStorage.getItem("token"))
			.get("/getallcourse", {
				signal: controller.signal,
			})
			.then(({ data }) => {
				console.log(data);
				setCourses(data.courses);
			})
			.catch((err) => console.log(err?.response));

		return () => controller.abort();
	}, []);

	useEffect(() => {
		if (course === "") return;

		const controller = new AbortController();

		developAxios(localStorage.getItem("token"))
			.get("/getCourse/" + course, {
				signal: controller.signal,
			})
			.then(({ data }) => {
				let course_data = data.data[0];
				console.log(course_data);
				setObjective(course_data.objective);
				setTakeaway(course_data.takeaway);
				setSchedule(course_data.schedule);
				setSelectLevel(course_data.courseLevel);
				// console.log(course_data.courseLevel);
				console.log(typeof course_data.schedule[0].date);
			})
			.catch(({ response }) => console.log(response));

		return () => controller.abort();
	}, [course]);

	const handleOnFileLoad = (data) => {
		console.log("---------------------------");
		console.log(data);
		console.log("---------------------------");
	};
	const handleOnError = (err, file, inputElem, reason) => {
		console.log(err);
	};

	const handleOnRemoveFile = (data) => {
		console.log("---------------------------");
		console.log(data);
		console.log("---------------------------");
	};

	const handleOpenDialog = (e) => {
		// Note that the ref is set async, so it might be null at some point
		if (buttonRef.current) {
			buttonRef.current.open(e);
		}
	};

	const handleRemoveFile = (e) => {
		// Note that the ref is set async, so it might be null at some point
		if (buttonRef.current) {
			buttonRef.current.removeFile(e);
		}
	};

	function handleSubmit() {
		// console.log(takeaway, selectLevel, objective);
		let post_data = {
			_id: course,
			objective,
			courseLevel: selectLevel,
			schedule,
			takeaway,
		};
		console.log(post_data);

		developAxios(localStorage.getItem("token"))
			.post("/dashboard/dashboard-overview-edit", post_data)
			.then(({ data }) => {
				store.addNotification({
					title: "Course Update",
					message: "successfuly updated",
					type: "success",
					insert: "top",
					container: "top-right",
					animationIn: ["animate__animated", "animate__fadeIn"],
					animationOut: ["animate__animated", "animate__fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
			})
			.catch(({ response }) => {
				alert(response.data.message);
			});
	}

	return (
		<div>
			<div className="overviewform">
				<div className="form-group">
					<h3>Overview Form</h3>
					<h5>Course Id:</h5>{" "}
					<select
						className="w-50"
						aria-label="Default select example"
						name="course_select"
						id="course_select"
						onChange={(e) => {
							setCourse(e.target.value);
						}}
					>
						<option value="">Select Course</option>
						{courses.map((val) => {
							return (
								<option value={val._id} key={val.id}>
									{val?.name}
								</option>
							);
						})}
					</select>
					<br />
					<label className="overviewLable" htmlFor="">
						Objective
					</label>
					<br />
					<textarea
						className="overviewtextarea"
						name=""
						id=""
						placeholder="Enter objective text"
						cols="10"
						onChange={(e) => setObjective(e.target.value)}
						rows="1"
						value={objective}
					>
						{objective}
					</textarea>
				</div>
				<div className="form-group suneditor">
					<label className="overviewLable" htmlFor="">
						Takeaway
					</label>
					<br />
					<SunEditor
						showToolbar={true}
						className="suneditor-textarea"
						setContents={takeaway}
						onChange={(e) => setTakeaway(e)}
						setOptions={{
							buttonList: [
								[
									"undo",
									"redo",
									"font",
									"fontSize",
									"formatBlock",
									"paragraphStyle",
									"blockquote",
									"bold",
									"underline",
									"italic",
									"strike",
									"subscript",
									"superscript",
									"fontColor",
									"hiliteColor",
									"textStyle",
									"removeFormat",
									"outdent",
									"indent",
									"align",
									"horizontalRule",
									"list",
									"lineHeight",
									"table",
									"link",
									"image",
									"video",
									"fullScreen",
									"showBlocks",
									"codeView",
								],
							],
						}}
					/>
				</div>
				<div className="form-group schedule">
					{schedule.length !== 0 && (
						<label className="overviewLable1" htmlFor="">
							Schedule
						</label>
					)}
					{schedule.map((val, index) => {
						return (
							<div
								className="row overviewrow align-items-center"
								key={index}
							>
								<div className="col">
									<input
										type="datetime-local"
										className="col-item"
										onChange={(e) =>
											updateSchedule(
												e.target.value,
												"date",
												index
											)
										}
										value={val.date.replace(":00.000Z", "")}
									/>
								</div>
								<div className="col">
									<input
										className="col-item"
										type="text"
										placeholder="Language"
										value={val.topic}
										onChange={(e) =>
											updateSchedule(
												e.target.value,
												"topic",
												index
											)
										}
									/>
								</div>
								<div className="col">
									<input
										className="col-item"
										type="text"
										placeholder="Description"
										value={val.subTopic}
										onChange={(e) =>
											updateSchedule(
												e.target.value,
												"subTopic",
												index
											)
										}
									/>
								</div>
								<div className="col">
									<input
										className="col-item"
										type="text"
										placeholder="Link"
										value={val.classLink}
										onChange={(e) =>
											updateSchedule(
												e.target.value,
												"classLink",
												index
											)
										}
									/>
								</div>
								<button
									className="col-sm-4 d-flex justify-content-center align-items-center rounded"
									onClick={() => removeInput(index)}
									style={{
										height: "25px",
										width: "25px",
										outlineStyle: "none",
										border: "none",
									}}
								>
									<img
										src="https://s2.svgbox.net/hero-outline.svg?ic=x-circle&color=red"
										alt="close-btn"
										height={24}
										width={24}
									/>
								</button>
							</div>
						);
					})}
				</div>
				<button className="overviewChangeBtn" onClick={addInput}>
					ADD SCHEDULE
				</button>

				<div className="form-group">
					<CSVReader
						ref={buttonRef}
						onFileLoad={handleOnFileLoad}
						onError={handleOnError}
						noClick
						noDrag
						onRemoveFile={handleOnRemoveFile}
					>
						{({ file }) => (
							<aside className="uploadOverViewinput">
								<button
									type="button"
									onClick={handleOpenDialog}
									className="browse-file-btn"
								>
									Browse file
								</button>

								<div className="upload-file-btn">
									{file && file.name}
								</div>
								<button
									className="upload-arrow-btn"
									onClick={handleRemoveFile}
								>
									<img
										src="https://cantileverlabs-quiz-answer-images.s3.ap-south-1.amazonaws.com/1656916147807_Group%209188.png"
										alt=""
									/>
								</button>
							</aside>
						)}
					</CSVReader>
				</div>

				<div>
					<button
						type="button"
						// onClick={handleOpenDialog}
						className="uploadScheduleBtn"
					>
						Upload
					</button>
				</div>

				<br />

				<div className="form-group m-1">
					<label htmlFor="">Select level</label>
					<br />
					<select
						className="custom-select w-50"
						id="inputGroupSelect05"
						aria-label="Example select with button addon"
						onChange={(e) => setSelectLevel(e.target.value)}
						value={selectLevel}
					>
						<option selected>Select</option>
						<option value="beginner">beginner</option>
						<option value="intermediate">intermediate</option>
						<option value="expert">expert</option>
					</select>
				</div>
				<button
					className="btn btn-primary overviewBtn"
					onClick={handleSubmit}
				>
					SUBMIT
				</button>
			</div>
		</div>
	);
}

export default OverviewForm;
